<div class="content-top-bar">
  <div class="left-pane">
    @if (showLeftMenuOpener) {
      <div class="margin-right">
        <button
          class="sidebar-toggle-btn"
          alg-button-icon
          type="button"
          icon="ph ph-list"
          aria-label="Open sidebar"
          i18n-aria-label
          algTooltip="Open sidebar"
          i18n-algTooltip
          tooltipPosition="right"
          (click)="showLeftMenu()"
        ></button>
      </div>
    }
    @if (isItemContentActive()) {
      <div class="margin-right score-section">
        @if (score(); as scoreVal) {
          <alg-score-ring
            [bestScore]="scoreVal.best"
            [currentScore]="scoreVal.current"
            [isValidated]="scoreVal.validated"
            [diameter]="32"
          ></alg-score-ring>
        }
      </div>
    }
    <ng-container *ngrxLet="{
      fullFrameContentDisplayed: fullFrameContentDisplayed$,
      shouldDisplayTabBar: shouldDisplayTabBar$,
      isNarrowScreen: isNarrowScreen$,
    } as behaviourInfo">
      @if (!behaviourInfo.isNarrowScreen || behaviourInfo.isNarrowScreen && !behaviourInfo.fullFrameContentDisplayed) {
        <div class="left-pane-title margin-right">
          @let titleVal = title();
          @if (!showBreadcrumbs && titleVal) {
            <p class="left-pane-title-text">{{ titleVal }}</p>
          } @else {
            <alg-breadcrumbs class="breadcrumbs"></alg-breadcrumbs>
          }
        </div>
      }
      @if (behaviourInfo.shouldDisplayTabBar && behaviourInfo.fullFrameContentDisplayed) {
        <alg-tab-bar
          class="tab-bar"
          styleClass="for-header"
        ></alg-tab-bar>
      }
    </ng-container>
  </div>
  <div class="right-pane">
    <alg-time-limited-content-info></alg-time-limited-content-info>
    <alg-observation-bar></alg-observation-bar>
    @if (navigationNeighbors$ | async; as navigationNeighbors) {
      <alg-neighbor-widget
        class="neighbor-widget margin-left"
        [navigationMode]="{
          parent: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.parent,
          left: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.previous,
          right: !!navigationNeighbors?.isReady && !!navigationNeighbors?.data?.next
        }"
        (parent)="navigationNeighbors?.data?.parent?.navigateTo()"
        (left)="navigationNeighbors?.data?.previous?.navigateTo()"
        (right)="navigationNeighbors?.data?.next?.navigateTo()"
      ></alg-neighbor-widget>
    }
  </div>
</div>
